// (function () {
//   'use strict';

//   window._klOnsite = window._klOnsite || [];
//   window.dataLayer = window.dataLayer || [];
//   console.log("test1",window._klOnsite.__inmoWrapped);
//   if (window._klOnsite.__inmoWrapped) return;
//   window._klOnsite.__inmoWrapped = true;
// console.log("test2");
//   var SUBSCRIBE_FORM_ID = 'TihNKE';

//   var originalPush = window._klOnsite.push;

//   function isSubscribeSuccess(call) {
//     if (!Array.isArray(call)) return false;
//     if (call[0] !== 'sendCachedEvents') return false;

//     var payload = call[2];
//     var meta = call[5];

//     var hasEmail = payload && typeof payload.$email === 'string' && payload.$email;
//     var isTargetForm = meta && meta.form && meta.form.data && meta.form.data.id === SUBSCRIBE_FORM_ID;

//     return Boolean(hasEmail && isTargetForm);
//   }

//   function pushConversion(call) {
//     console.log('push to gtm');
//     var meta = call[5];
//     var formVersion = meta && meta['form-version'] && meta['form-version'].data;

//     window.dataLayer.push({
//       event: 'newsletter_subscribe',
//       form_id: SUBSCRIBE_FORM_ID,
//       form_version: (formVersion && formVersion.id) || null,
//       subscribe_method: 'klaviyo',
//     });
//   }

//   window._klOnsite.push = function () {
//     var args = Array.prototype.slice.call(arguments);
//     console.log("test",args);
//     for (var i = 0; i < args.length; i++) {
//       try {
//         if (isSubscribeSuccess(args[i])) {
//           pushConversion(args[i]);
//         }
//       } catch (err) {
//         if (window.console && console.warn) {
//           console.warn('[newsletter-conversion] 处理失败', err);
//         }
//       }
//     }

//     return originalPush.apply(this, args);
//   };
// })();


(function () {
  'use strict';

  window._klOnsite = window._klOnsite || [];
  window.dataLayer = window.dataLayer || [];

  var klOnsite = window._klOnsite;
  if (klOnsite.__inmoWrapped) return;
  klOnsite.__inmoWrapped = true;

  var SUBSCRIBE_FORM_ID = 'TihNKE';

  function isSubscribeSuccess(call) {
    if (!Array.isArray(call)) return false;
    if (call[0] !== 'sendCachedEvents') return false;

    var payload = call[2];
    var meta = call[5];

    var hasEmail = payload && typeof payload.$email === 'string' && payload.$email;
    var isTargetForm = meta && meta.form && meta.form.data && meta.form.data.id === SUBSCRIBE_FORM_ID;

    return Boolean(hasEmail && isTargetForm);
  }

  function pushConversion(call) {
    // console.log('push to gtm');
    var meta = call[5];
    var formVersion = meta && meta['form-version'] && meta['form-version'].data;

    window.dataLayer.push({
      event: 'newsletter_subscribe',
      form_id: SUBSCRIBE_FORM_ID,
      form_version: (formVersion && formVersion.id) || null,
      subscribe_method: 'klaviyo',
    });
  }

  function wrapPush(fn) {
    return function (call) {
      try {
        // 临时调试:先无条件打印,确认真实数据结构里 payload/meta 到底在第几位
        // if (Array.isArray(call) && call[0] === 'sendCachedEvents') console.log('[debug] raw call', call);

        if (isSubscribeSuccess(call)) {
          pushConversion(call);
        }
      } catch (err) {
        if (window.console && console.warn) {
          console.warn('[newsletter-conversion] 处理失败', err);
        }
      }
      return fn.apply(this, arguments);
    };
  }

  var currentPush = wrapPush(klOnsite.push);

  Object.defineProperty(klOnsite, 'push', {
    configurable: true,
    get: function () { return currentPush; },
    set: function (fn) { currentPush = wrapPush(fn); },
  });
})();